<template>
  <div class="container">
    <div class="col-lg-8 col-md-8 ml-auto mr-auto">
      <form @submit.prevent="register">
        <card class="card-register card-white">
          <template slot="header">
            <img class="card-img" src="img/card-primary.png" alt="Card image"/>
            <h4 class="card-title" style="color: black">Бүртгүүлэх</h4>
          </template>
          <base-input
            v-validate="'required|email'"
            :error="getError('email')"
            v-model="model.email"
            name="email"
            placeholder="Email"
            addon-left-icon="tim-icons icon-email-85"
          >
          </base-input>
          <el-tooltip class="item" effect="dark" content="Таны нууц үг том жижиг үсэг болон тэмдэгт орсон байх ёстойг анхаарна уу!" placement="bottom">
            <base-input
            v-validate="'required|min:8'"
            :error="getError('password')"
            v-model="model.password"
            name="password"
            type="password"
            placeholder="Password"
            addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </el-tooltip>

          <base-checkbox class="text-left">
            I agree to the <a href="#something">terms and conditions</a>.
          </base-checkbox>

          <base-button native-type="submit" slot="footer" type="primary" round block size="lg">
            Бүртгүүлэх
          </base-button>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox } from 'src/components';
import { signUp } from '@/utils/auth.js'
export default {
  components: {
    BaseCheckbox
  },
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async register() {
      signUp(this.model.email, this.model.password)
      // let isValidForm = await this.$validator.validateAll();
      // if (isValidForm) {
        // TIP use this.model to send it to api and perform register call
      // }
    }
  }
};
</script>
<style></style>
